import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { List as ImmutableList } from 'immutable';
import NavigationMenuItemView from './NavigationMenuItemView.jsx';
import NavigationMenuItemDividerView from './NavigationMenuItemDividerView.jsx';
import SearchInput from '../../Forms/SearchInputView.jsx';
import Configuration from '../../../Globals/Scripts/Configuration';
import ClassNames from 'classnames';
import $ from 'jquery';
import NavigationStore from '../../../Stores/NavigationStore';

class NavigationDropdownMenuItemView extends React.Component {
    componentDidMount () {
        $(ReactDOM.findDOMNode(this)).dropdown({
            fullTextSearch: true,
            duration: 0,
            action: 'hide',
            selector: {
                dropdown: '.dropdown.item'
            },
            className: {
              dropdown: 'dropdown item'
            },
            onHide: this.onDropdownHide
        });
    }

    isActive(label) {
        const { currentMenuSelection } = NavigationStore.getState();
        return currentMenuSelection && currentMenuSelection[0] === label;
    }

    onDropdownHide() {
        const dropdown = $(this);
        const searchInput = dropdown.find('.search.input input');
        searchInput.val('');
        dropdown.dropdown('filterItems', '');
        document.body.focus();
    }

    render() {
        const menuItemGroups = this.props.menuItems;
        const totalMenuItemCount = menuItemGroups
        .map(item => ImmutableList(item.keys()).count())
        .reduce((a, b) => a + b);

        if(totalMenuItemCount > 15) {
            return this.renderSearchDropdown(menuItemGroups);
        }
        else {
            return this.renderStandardDropdown(menuItemGroups);
        }
    }

    renderSearchDropdown(menuItemGroups) {
        const active = this.isActive(this.props.label);
        return (
            <li className={ ClassNames({selected: active}, 'dropdown', 'item') } title={ this.props.label } tabIndex="0">
                <button className="text" title={ this.props.label } tabIndex="-1"><span>{ this.props.label }</span></button>
                <i className="dropdown icon"></i>
                <div className="menu hidden">
                    <SearchInput />
                    <div className="header">{ this.props.label }</div>
                    <ul className="scrolling menu" tabIndex="-1">
                    {
                        this.renderMenuItemGroups(menuItemGroups, active)
                    }
                    </ul>
                </div>
            </li>
        );
    }

    renderStandardDropdown(menuItemGroups) {
        const active = this.isActive(this.props.label);
        return (
            <li className={ ClassNames({selected: active}, 'dropdown', 'item') } title={ this.props.label } tabIndex="0">
                <button className="text" title={ this.props.label } tabIndex="-1"><span>{ this.props.label }</span></button>
                <i className="dropdown icon"></i>
                <ul className="menu hidden" tabIndex="-1">
                {
                    this.renderMenuItemGroups(menuItemGroups, active)
                }
                </ul>
            </li>
        );
    }

    renderMenuItemGroups(menuItemGroups, parentActive){
        // This is to prevent the last menu item from having a divider.
        const indexOfLastGroup = menuItemGroups.size - 1;
        return menuItemGroups.map((item, index) => this.renderMenuItemGroup(item, index, parentActive, index < indexOfLastGroup)).flatten(); //Flatten nested array
    }

    renderMenuItemGroup(menuItemGroup, groupIndex, parentActive, appendDivider){
        const menuItemLabels = ImmutableList(menuItemGroup.keys());

        const menuItems = menuItemLabels.map((menuItemLabel, itemIndex) => {
            const menuItemHref = menuItemGroup.get(menuItemLabel);
            return (<NavigationMenuItemView key={ groupIndex.toString() + '_' + itemIndex.toString() } parentActive={ parentActive } label={ menuItemLabel } href={ menuItemHref } />);
        });

        // ImmutableList's push method returns a new List, it does not modify the original list.
        return appendDivider
            ? menuItems.push(<NavigationMenuItemDividerView key={ 'd_' + groupIndex.toString() } />)
            : menuItems;
    }
}

NavigationDropdownMenuItemView.propTypes = {
    label: PropTypes.string.isRequired,
    menuItems: PropTypes.object.isRequired
};

export default NavigationDropdownMenuItemView;
